// #html-loader is visible by default (see shared/_header.scss) to prevent a
// flash of unstyled content; something must always hide it once the page is ready.
const hideLoader = function () {
  const loader = document.getElementById('html-loader');
  if (!loader) return;
  loader.style.display = 'none';
  document.body.style.overflow = '';
};

export default hideLoader;
